<div nz-row [nzGutter]="[48, 24]">
  <div nz-col nzSpan="24" *ngIf="structure?.logo?.urlWithDomain">
    <img [src]="structure?.logo?.urlWithDomain" alt="Logo {{ structure?.name }}" class="logo">
  </div>

  <div nz-col nzSpan="24">
    <div nz-row [nzGutter]="[48, 0]">
      <div nz-col>
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">Statut</span>
          <span class="detail-content" nz-typography>
            <i nz-icon [nzType]="structure?.active ? 'check-square' : 'close-square'" nzTheme="outline"></i>
            {{ structure?.active ? 'Activé' : 'Désactivé' }}
          </span>
        </div>
      </div>

      <div nz-col>
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">Nom</span>
          <span class="detail-content" nz-typography>{{ structure?.name }}</span>
        </div>
      </div>

      <div nz-col>
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">Raison Sociale</span>
          <span class="detail-content" nz-typography>{{ structure?.name2 }}</span>
        </div>
      </div>

    </div>
  </div>

  <div nz-col nzSpan="24">
    <div class="detail">
      <span class="detail-title" nz-typography nzType="secondary">Adresse</span>
      <span class="detail-content" nz-typography>{{ structure?.fullAddress | nullCoal }}</span>
    </div>
  </div>



  <div nz-col nzSpan="24">
    <div class="detail">
      <span class="detail-title" nz-typography nzType="secondary">Préparateurs</span>
      <span class="detail-content" nz-typography>
        <button
          nz-button
          nzSize="large"
          [routerLink]="['/', 'admin', 'preparers']"
          [queryParams]="{ s: structure?.name }"
          [disabled]="structure?.preparersMetaData?.totalResults === 0">
          {{ structure ? preparers(structure) : null }}<i nz-icon nzType="right-square"></i>
        </button>
      </span>
    </div>
  </div>

  <div nz-col nzSpan="24">
    <div class="detail">
      <span class="detail-title" nz-typography nzType="secondary">Site client</span>
      <span class="detail-content" nz-typography>
        <button
          nz-button
          nzSize="large"
          [routerLink]="['/', 'admin', 'customer-sites']"
          [queryParams]="{ s: structure?.name }"
          [disabled]="structure?.customerSitesMetaData?.totalResults === 0">
          {{ structure ? customerSites(structure) : null }}<i nz-icon nzType="right-square"></i>
        </button>
      </span>
    </div>
  </div>




  <div nz-col nzSpan="24">
    <laveo-list-contacts [contacts]="structure ? structure.contacts : []" [showNotificationsCheckbox]="true"></laveo-list-contacts>
  </div>




  <div nz-col nzSpan="24">
    <laveo-divider title="Facturation" icon="euro"></laveo-divider>

    <div nz-row [nzGutter]="[48, 0]">

      <div nz-col nzSpan="4">
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">Auto-facturation</span>
          <span class="detail-content" nz-typography>
            <i nz-icon [nzType]="structure?.isAutoInvoiceEnabled ? 'check-square' : 'close-square'" nzTheme="outline"></i>
            {{ structure?.isAutoInvoiceEnabled ? 'Activé' : 'Désactivé' }}
          </span>
        </div>
      </div>

      <div nz-col nzSpan="4">
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">TVA Applicable</span>
          <span class="detail-content" nz-typography>
            <i nz-icon [nzType]="structure?.hasVat ? 'check-square' : 'close-square'" nzTheme="outline"></i>
            {{ structure?.hasVat ? 'Oui' : 'Non' }}
          </span>
        </div>
      </div>
      <div nz-col nzSpan="8">
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">SIRET</span>
          <span class="detail-content" nz-typography>{{ structure?.registrationId | nullCoal }}</span>
        </div>
      </div>
      <div nz-col nzSpan="8">
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">Num. TVA Intracommunautaire</span>
          <span class="detail-content" nz-typography>{{ structure?.vatNumber | nullCoal }}</span>
        </div>
      </div>
      <div nz-col nzSpan="12">
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">Forme juridique</span>
          <span class="detail-content" nz-typography>{{ structure?.legalStatus | nullCoal }}</span>
        </div>
      </div>
      <div nz-col nzSpan="12">
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">Capital Social</span>
          <span class="detail-content" nz-typography>{{ structure?.shareCapital  | currency:'EUR' }} </span>
        </div>
      </div>
      <div nz-col nzSpan="8">
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">Numéro RCS</span>
          <span class="detail-content" nz-typography>{{ structure?.rcsNumber  | nullCoal }} </span>
        </div>
      </div>
      <div nz-col nzSpan="8">
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">Ville du greffe (R.C.S)</span>
          <span class="detail-content" nz-typography>{{ structure?.rcsCity  | nullCoal }} </span>
        </div>
      </div>

      <div nz-col nzSpan="8">
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">Code NAF</span>
          <span class="detail-content" nz-typography>{{ structure?.nafCode  | nullCoal }} </span>
        </div>
      </div>

      <div nz-col nzSpan="6">
        <div class="detail">
          <span class="detail-title" nz-typography nzType="secondary">Autre information de facturation</span>
          <span class="detail-content" nz-typography>{{ structure?.otherInvoiceInfo  | nullCoal }} </span>
        </div>
      </div>
    </div>

  </div>
</div>
